import api from 'api'

export type HighnotePaymentMethodResponse = {
  id: number
  brand: string
  last4: string
  expiryYear: number
  expiryMonth: number
  cardHolderName: string | null
  archivedAt: string | null
}

export type HighnotePaymentMethodsResponse = {
  paymentMethods: HighnotePaymentMethodResponse[]
}

export type HighnoteExternalBankAccountResponse = {
  id: number
  last4: string
  routingNumber: string
  name: string | null
  bankAccountType: string | null
  archivedAt: string | null
}

export type HighnoteExternalBankAccountsResponse = {
  externalBankAccounts: HighnoteExternalBankAccountResponse[]
}

export type GetUserPaymentMethodOptions = {
  userId: number
}

export const getUserPaymentMethods = async ({
  userId,
}: GetUserPaymentMethodOptions): Promise<HighnotePaymentMethodsResponse> => {
  const response = await api.get(
    `/admin/user_payments/${userId}/payment_method`
  )
  return response.data
}

export type GetUserExternalBankAccountOptions = {
  userId: number
}

export const getUserExternalBankAccounts = async ({
  userId,
}: GetUserExternalBankAccountOptions): Promise<HighnoteExternalBankAccountsResponse> => {
  const response = await api.get(
    `/admin/user_payments/${userId}/external_bank_account`
  )
  return response.data
}
